RCDPW.module('RCDPW.validator.messages', {
    appEnv: RCDPW.Lang.Validator.ERROR_APP_ENV,
    integration: RCDPW.Lang.Validator.ERROR_INTEGRATION,
    integrationOther: '', // integrationOther use the same message as integration.
    developmentStartDate: RCDPW.Lang.Validator.ERROR_DATE_INVALID,
    productionDate: RCDPW.Lang.Validator.ERROR_DATE_INVALID,
    proDateMinusDevDate: RCDPW.Lang.Validator.ERROR_DATE_INVALID,
    applicationTypes: RCDPW.Lang.Validator.signUp.APPLICATION_TYPE,
    useCases: RCDPW.Lang.Validator.signUp.USE_CASES,
    Other: ''
});